import ApiService from "@/common/api.service";

export const GET_PENDING_EMAIL_OFFERS = "getPendingEmailOffers";
export const GET_EMAIL_OFFER = "getEmailOffer";
export const DOWNLOAD_EMAIL_OFFER_ATTACHMENT = "downloadEmailOfferAttachment";
export const FETCH_EMAIL_OFFER_ATTACHMENT = "fetchEmailOfferAttachment";
export const DELETE_EMAIL_OFFER = "deleteEmailOffer";

const actions = {
  [GET_PENDING_EMAIL_OFFERS]() {
    return new Promise((resolve, reject) => {
      ApiService.query("emailOffers")
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [GET_EMAIL_OFFER](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get("emailOffers", id)
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [DOWNLOAD_EMAIL_OFFER_ATTACHMENT](context, { emailOfferId, attachmentId, fileName }) {
    return ApiService.downloadFile(
      `emailOffers/${emailOfferId}/attachments/${attachmentId}`,
      fileName || "attachment"
    );
  },
  [FETCH_EMAIL_OFFER_ATTACHMENT](context, { emailOfferId, attachmentId }) {
    return ApiService.getBlob(
      `emailOffers/${emailOfferId}/attachments/${attachmentId}`
    );
  },
  [DELETE_EMAIL_OFFER](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.delete(`emailOffers/${id}`)
        .then(() => {
          resolve();
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
};

export default {
  actions
};
